"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGenericErrorMessageResult = exports.AggregateMessageResultSchemaDefault = exports.MessageResultSchemaDefault = void 0;
exports.MessageResultSchema = MessageResultSchema;
exports.AggregateMessageResultSchema = AggregateMessageResultSchema;
exports.PossibleAggregateMessageResultSchema = PossibleAggregateMessageResultSchema;
exports.computeAggragateMessageResultSeverity = computeAggragateMessageResultSeverity;
exports.errorToMessageResult = errorToMessageResult;
exports.scoreMessageResult = scoreMessageResult;
exports.stripMessageResultExtraProperties = stripMessageResultExtraProperties;
const zod_1 = require("zod");
const BoundaryLevel_1 = require("./BoundaryLevel");
const BoundaryLevel_2 = require("./BoundaryLevel");
function MessageResultSchema(messageType, innerResultSchema) {
    return zod_1.default
        .object({
        type: messageType,
        message: zod_1.default.string(),
        severity: zod_1.default.nativeEnum(BoundaryLevel_2.BoundaryLevel).optional(),
        innerResult: innerResultSchema.optional(),
    })
        .passthrough();
}
exports.MessageResultSchemaDefault = MessageResultSchema(zod_1.default.string(), zod_1.default.lazy(() => exports.MessageResultSchemaDefault));
function AggregateMessageResultSchema(typeEnum, innerResultSchema) {
    return zod_1.default
        .object({
        type: typeEnum,
        message: zod_1.default.string(),
        severity: zod_1.default.nativeEnum(BoundaryLevel_2.BoundaryLevel).optional(),
        innerResults: innerResultSchema.array(),
    })
        .passthrough();
}
exports.AggregateMessageResultSchemaDefault = AggregateMessageResultSchema(zod_1.default.string(), exports.MessageResultSchemaDefault);
function PossibleAggregateMessageResultSchema(typeEnum, innerResultSchema) {
    return zod_1.default
        .object({
        type: zod_1.default.nativeEnum(typeEnum),
        message: zod_1.default.string(),
        severity: zod_1.default.nativeEnum(BoundaryLevel_2.BoundaryLevel).optional(),
        innerResults: innerResultSchema.array().optional(),
    })
        .passthrough();
}
function computeAggragateMessageResultSeverity(result) {
    result.severity =
        result.innerResults?.reduce((p, c) => (0, BoundaryLevel_1.getHighestBoundaryLevel)(p, c.severity ?? BoundaryLevel_2.BoundaryLevel.Recommendation), BoundaryLevel_2.BoundaryLevel.Recommendation) ?? BoundaryLevel_2.BoundaryLevel.Recommendation;
}
var TGenericErrorMessageResult;
(function (TGenericErrorMessageResult) {
    TGenericErrorMessageResult["UnknownError"] = "UnknownError";
    TGenericErrorMessageResult["Error"] = "Error";
    TGenericErrorMessageResult["AggregateError"] = "AggregateError";
})(TGenericErrorMessageResult || (exports.TGenericErrorMessageResult = TGenericErrorMessageResult = {}));
function errorToMessageResult(error) {
    if (error && typeof error === 'object') {
        if (typeof AggregateError !== 'undefined' && error instanceof AggregateError) {
            return {
                type: TGenericErrorMessageResult.AggregateError,
                message: 'An aggregate error occurred',
                severity: BoundaryLevel_2.BoundaryLevel.Error,
                innerResults: error.errors.map((innerError) => errorToMessageResult(innerError instanceof Error ? innerError : new Error(String(innerError)))),
            };
        }
        const walkable = {};
        const cause = error.innerError;
        if (cause instanceof Error) {
            walkable.innerResult = errorToMessageResult(cause);
        }
        let jsonProps = {};
        if (error instanceof Error && 'toJSON' in error && typeof error.toJSON === 'function') {
            jsonProps = error.toJSON();
            delete jsonProps.innerError;
        }
        if (error instanceof Error) {
            return {
                ...jsonProps,
                ...walkable,
                type: TGenericErrorMessageResult.Error,
                message: error.message,
                severity: BoundaryLevel_2.BoundaryLevel.Error,
                stack: error.stack || '',
                errorClass: error?.constructor?.name,
            };
        }
        const err = error;
        if ('message' in err && typeof err.message === 'string') {
            return {
                ...jsonProps,
                ...walkable,
                type: TGenericErrorMessageResult.Error,
                message: err.message,
                severity: BoundaryLevel_2.BoundaryLevel.Error,
                stack: err.stack?.toString() || new Error().stack || '',
            };
        }
    }
    return {
        type: TGenericErrorMessageResult.UnknownError,
        message: 'An unknown error occurred',
        severity: BoundaryLevel_2.BoundaryLevel.Error,
        stack: new Error().stack || '',
    };
}
function scoreMessageResult(result, errorScore = 0, warningScore = 0.5, recommendationScore = 0.9, defaultScore = 1) {
    if (result.innerResults?.length) {
        result.score =
            result.innerResults
                .map((innerResult) => scoreMessageResult(innerResult, errorScore, warningScore, recommendationScore, defaultScore))
                .reduce((a, b) => a + b, 0) / result.innerResults.length;
    }
    else if (result.severity === BoundaryLevel_2.BoundaryLevel.Error) {
        result.score = errorScore;
    }
    else if (result.severity === BoundaryLevel_2.BoundaryLevel.Warning) {
        result.score = warningScore;
    }
    else if (result.severity === BoundaryLevel_2.BoundaryLevel.Recommendation) {
        result.score = recommendationScore;
    }
    else {
        result.score = defaultScore;
    }
    return result.score;
}
function stripMessageResultExtraProperties(result) {
    const cleanResult = {
        type: result.type,
        message: result.message,
        severity: result.severity,
    };
    if (result.innerResults) {
        cleanResult.innerResults = result.innerResults.map((innerResult) => stripMessageResultExtraProperties(innerResult));
    }
    return cleanResult;
}
//# sourceMappingURL=MessageResult.js.map